import {
  admissionOnlyWorkflowOption,
  mapTemplateWorkflowTypesToOptions,
} from "../atoms/start-workflow/workflowMapping";
import {WorkflowOption} from "../atoms/start-workflow/types";

import {DocumentService} from "./DocumentService";

type TemplateVersionResponse = Readonly<{
  workflowTypes?: ReadonlyArray<string>;
}>;

/**
 * Response shape for facility workflows derived from the latest template version.
 */
export type FacilityWorkflowsResponse = Readonly<{
  workflows: ReadonlyArray<WorkflowOption>;
}>;

export const WorkflowService = {
  /**
   * Fetches workflow types enabled for a facility from the latest template version.
   */
  async getFacilityWorkflows(
    facilityId: string,
  ): Promise<FacilityWorkflowsResponse> {
    if (!facilityId) {
      return {workflows: [admissionOnlyWorkflowOption()]};
    }

    const {data: version} =
      await DocumentService.getLatestTemplateVersion(facilityId);

    const workflowTypes =
      (version as TemplateVersionResponse).workflowTypes ?? [];

    return {
      workflows: mapTemplateWorkflowTypesToOptions(workflowTypes),
    };
  },
};
